import EntityType from '@enums/EntityType';

/**
 * Filter child items that are the same as their parent item.
 *
 * @param {Object} - entity
 * @param {Object} - item
 * @param {Object} - parentItem
 *
 * @return {Boolean}
 */
export function filterSameAsParent(entity, item, parentItem) {
  if (!parentItem) {
    return false;
  }

  const isSameType = item.type === parentItem.type;

  if (!isSameType) {
    return false;
  }

  if (!item.subType && !parentItem.subType) {
    return parentItem.typeId === entity.uuid;
  }

  const isSameSubType = item.subType === parentItem.subType;

  if (isSameSubType) {
    if (item.subType === EntityType.ROLE_TYPE) {
      return parentItem.subTypeId === entity.title;
    }
    if (item.subType === EntityType.ACTIVITY_TYPE) {
      return parentItem.subTypeId === entity.library_uuid;
    }
  }

  return false;
}

/**
 * Filter items by allowable ids.
 *
 * @param {Object} - entity
 * @param {Object} - item
 * @param {Object} - parentItem
 *
 * @return {Boolean}
 */
export default function filterEntity(entity, item, parentItem) {
  if (!item.allowedIds && !item.allowedSubIds && !item.allowedValues) {
    return;
  }

  if (!item.subType) {
    const id = item?.allowedSubIds
      ? entity.uuid
      : entity.library_uuid || entity.uuid;
    const validator = item.allowedSubIds ? item.allowedSubIds : item.allowedIds;
    return !validator.has(id);
  }

  if (item.subType === EntityType.ROLE_TYPE) {
    const id = entity.uuid;
    const validator = item.allowedSubIds;
    return !validator.has(id);
  }
}
